/**
 * Simple wrapper function around Promise.allSettled to support Legacy Edge, Firefox for Android,
 * and Samsung Internet browsers that do not implement the function.
 * @param promises - An array of promises.
 * @returns An array of objects containing the result of each promise as resolved or rejected.
 */
export function allSettledPolyfill<T = unknown>(promises: Promise<T>[]) {
  if (Promise.allSettled) {
    return Promise.allSettled(promises);
  }

  return Promise.all(
    promises.map((promise) =>
      promise.then(
        (value) => ({ status: 'fulfilled', value }),
        (reason) => ({ status: 'rejected', reason }),
      ),
    ),
  );
}
